import type { PersonInvolvementKind } from "../types/involvement.js";

// A total `Record`, so admitting a kind without deciding its cardinality
// does not compile.
const oneHolderAtMostByKind: Record<PersonInvolvementKind, boolean> = {
  created_by: true,
  duty_of_care: true,
  placement: true,
  responsible_user: true,
  designated_assessor: true,
  approver: true,
  assessor: false,
  viewer: false,
  shared_assessment_reader: false,
};

/**
 * Whether a kind of involvement has at most one unended holder per person: an
 * expired holder still counts until it is ended.
 *
 * The database enforces the same rule; stating it here lets a screen say "one"
 * rather than offer a second holder the write would refuse.
 */
export const isInvolvementKindHeldByOneAtMost = (
  kind: PersonInvolvementKind,
): boolean => oneHolderAtMostByKind[kind];
